import { MRT_ColumnDef } from "material-react-table";
import { TFunction } from "i18next";
import { DATE_FILTER_OPTIONS } from "./constants";

function timestampLocale(): string {
	const locale =
		(typeof localStorage !== "undefined" && localStorage.getItem("i18nextLng")) ||
		"en";
	return locale.toLowerCase().startsWith("fr") ? "fr-FR" : "en-US";
}

export const TIMESTAMP_COLUMN_IDS = ["created", "updated"] as const;

export type TimestampField = (typeof TIMESTAMP_COLUMN_IDS)[number];

export function rowTimestamp(row: any, field: TimestampField): unknown {
	if (!row) return null;
	if (field === "created") {
		return row.created ?? row.createdAt ?? row.created_at ?? null;
	}
	return row.updated ?? row.updatedAt ?? row.updated_at ?? null;
}

export function formatTimestamp(value: unknown): string {
	if (value == null || value === "") return "";
	const date = value instanceof Date ? value : new Date(value as string);
	if (Number.isNaN(date.getTime())) return "";
	return date.toLocaleString(timestampLocale());
}

export function columnsHaveTimestamps(columns: MRT_ColumnDef<any>[]): boolean {
	return columns.some((col) => {
		const key = String(col.id || col.accessorKey || "");
		return key === "created" || key === "updated";
	});
}

export function createTimestampColumns(t: TFunction): MRT_ColumnDef<any>[] {
	return TIMESTAMP_COLUMN_IDS.map((field) => ({
		id: field,
		header: t(`common:tables.${field}`),
		accessorFn: (row: any) => {
			const raw = rowTimestamp(row, field);
			if (raw == null || raw === "") return null;
			const date = raw instanceof Date ? raw : new Date(raw as string);
			return Number.isNaN(date.getTime()) ? null : date;
		},
		Cell: ({ cell }: { cell: any }) => formatTimestamp(cell.getValue()),
		filterVariant: "datetime-range",
		columnFilterModeOptions: DATE_FILTER_OPTIONS,
	}));
}
